module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-07.91e2ec4a.jpg";